import { Typography, Tooltip } from "@mui/joy";
import { Question } from "@phosphor-icons/react";
import type { Deal } from "../../lib/proposalDealsApi";
const money = (v?: string) =>
  Number(v || 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
export function RepairDiscountFields({
  type = "amount",
  value = "0.00",
  label,
}: {
  type?: string;
  value?: string;
  label: string;
}) {
  return (
    <div className="deal-fields">
      <label>
        {label} type{" "}
        <Tooltip title="Dollar discounts reduce the extended line price (quantity × unit price) or the proposal subtotal. Percentage discounts use that same amount. Discounts are applied before tax.">
          <span tabIndex={0} aria-label="How discounts work">
            <Question />
          </span>
        </Tooltip>
        <select name="discount_type" defaultValue={type}>
          <option value="amount">Dollar amount ($)</option>
          <option value="percent">Percentage (%)</option>
        </select>
      </label>
      <label>
        {label} value
        <input
          name="discount_value"
          type="number"
          min="0"
          step="0.01"
          defaultValue={value}
          required
        />
      </label>
    </div>
  );
}
export function RepairPriceBreakdown({ totals }: { totals: Deal["totals"] }) {
  return (
    <dl>
      {Number(totals?.discount_total) > 0 && (
        <>
          <div>
            <dt>Before discounts</dt>
            <dd>{money(totals?.gross_subtotal)}</dd>
          </div>
          {Number(totals?.line_discount) > 0 && (
            <div>
              <dt>Line item discounts</dt>
              <dd>−{money(totals?.line_discount)}</dd>
            </div>
          )}
          {Number(totals?.proposal_discount) > 0 && (
            <div>
              <dt>Proposal discount</dt>
              <dd>−{money(totals?.proposal_discount)}</dd>
            </div>
          )}
        </>
      )}
      <div>
        <dt>Subtotal</dt>
        <dd>{money(totals?.subtotal)}</dd>
      </div>
      <div>
        <dt>Tax</dt>
        <dd>{money(totals?.tax)}</dd>
      </div>
      <div className="deal-total">
        <dt>Total</dt>
        <dd>
          <Typography fontWeight="lg">{money(totals?.total)}</Typography>
        </dd>
      </div>
    </dl>
  );
}
